import { Paragraph } from '@vimeo/iris/typography';

export default function Tags() {
  return (
    <div>
      <Paragraph size="2">
        <em>Tags</em> are pieces of metadata for categorizing or labeling videos.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
